import React from "react";

const CourseFeedbackSkeleton = () => (
  <div className="flex flex-col animate-pulse">
    {/* Stars */}
    <div className="flex gap-3 mb-6 justify-center">
      {[...Array(5)].map((_, i) => (
        <svg key={`star-${i}`} width="28" height="28" viewBox="0 0 24 24" fill="#D9D9D9" stroke="#D9D9D9" strokeWidth="1.5">
          <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" />
        </svg>
      ))}
    </div>

    {/* Emoji + label */}
    <div className="flex items-center gap-2 mb-5">
      <div className="w-8 h-8 rounded-full bg-neutral-5" />
      <div className="h-4 w-44 bg-neutral-5 rounded" />
    </div>

    {/* Tag pills */}
    <div className="flex flex-wrap gap-2 mb-6">
      {[110, 145, 125, 155, 130].map((w, i) => (
        <div key={`tag-${i}`} style={{ width: w }} className="h-7 bg-neutral-5 rounded-md" />
      ))}
    </div>

    {/* Textarea label */}
    <div className="h-5 w-52 bg-neutral-5 rounded mb-3" />

    {/* Textarea */}
    <div className="w-full h-36 bg-neutral-5 rounded-lg mb-8" />

    {/* Footer */}
    <div className="flex items-center justify-end gap-4">
      <div className="h-10 w-40 bg-neutral-5 rounded-lg" />
      <div className="h-10 w-40 bg-neutral-5 rounded-lg" />
    </div>
  </div>
);

export default CourseFeedbackSkeleton;
